import combineStyles from 'components/Templates/general/combineStyles';

import {
  wrapperStyles,
  galleryImagesStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  galleryRoundTilesStyles,
  galleryRoundTilesMobileStyles,
  typoHeader,
  typoHeaderMobile,
  typoParagraph,
} from 'components/Templates/styles/Red/commonObjectsStyles';


import imageOne from 'components/Templates/styles/Red/assets/JPG/textimage.jpg';
import imageTwo from 'components/Templates/styles/Red/assets/JPG/venue.jpg';
import imageThree from 'components/Templates/styles/Red/assets/JPG/video.jpg';


/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color' : '{backgroundColor}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  sectionTitle: {
    '0': {
      ...typoHeader,
    },
    '76_8' : {
      ...typoHeaderMobile,
    },
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'margin-bottom' : '5rem'
    },
    '76_8' : {
      'margin-bottom' : '3rem'
    }
  },
  imageGalleryWrapper: {
    '0': {
      'display' : 'flex',
      'justify-content' : 'space-between',
      'margin-top' : '5rem'
    },
    '37_5' : {
      'justify-content' : 'center',
      'flex-direction' : 'column'
    }
  },
  imageWrapper: {
    '0': {
      'width': '32%',
      'height': '100%'
    },
    '76_8' : {
      'min-width': '25%'
    },
    '37_5' : {
      'width': '100%'
    }
  },
  imageOneWrapper: {},
  imageOne: {
    '0': {
      ...galleryImagesStyles,
      ...galleryRoundTilesStyles,
      'background-image': `url(${imageOne})`,
    },
    '37_5' : {
      ...galleryRoundTilesMobileStyles
    }
  },
  imageOneHeader: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '2rem'
    },
  },
  imageOneParagraph: {
    '0': {
      'font-size': '1.6rem',
      'margin-top': '2rem'
    },
  },
  imageTwoWrapper: {},
  imageTwo: {
    '0': {
      ...galleryImagesStyles,
      ...galleryRoundTilesStyles,
      'background-image': `url(${imageTwo})`
    },
    '37_5' : {
      ...galleryRoundTilesMobileStyles
    }
  },
  imageTwoHeader: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '2rem'
    },
  },
  imageTwoParagraph: {
    '0': {
      'font-size': '1.6rem',
      'margin-top': '2rem'
    },
  },
  imageThreeWrapper: {},
  imageThree: {
    '0': {
      ...galleryImagesStyles,
      ...galleryRoundTilesStyles,
      'background-image': `url(${imageThree})`
    },
    '37_5' : {
      ...galleryRoundTilesMobileStyles
    }
  },
  imageThreeHeader: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '2rem'
    },
  },
  imageThreeParagraph: {
    '0': {
      'font-size': '1.6rem',
      'margin-top': '2rem'
    },
  },
};

export default thisStyle;
